import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, InvoiceService } from "../../../services/index";
import * as fromCommonStore from "../../../store";

@Component({
  selector: "invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./invoice.component.html",
})
export class PurchaseInvoiceComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  invoiceData: any[];
  menu : any;

  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  gridOptions: any;
  partyCtrl: FormControl = new FormControl();
  partyList$ = [];
  partyList: Observable<any[]>;

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "inv.inv_id",
    orderDir: "desc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;

  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData: any = {
    filterinvno: "",
    party: "",
    po_no: "",
    inv_from_date: "",
    inv_to_date: "",
    finyear: "",
  };
  finyearList = [];
  partyStoreSub;
  itemStoreSub;
  invoiceStoreSub;

  printConfig: any = {
    title: "Sales Invoice",
    columns: [],
    rows: [],
  };
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private invoiceService: InvoiceService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private combo2Service: Combo2Service
  ) {
    /*   this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
           this.filterData.company_id = this.companyInfo.id;
           */
    this.invoiceStoreSub = this.store
      .select(fromRootStore.getLoadInvoice)
      .subscribe((isLoad: any) => {
        if (isLoad) {
          this.getInvoiceList();
        }
      });

    this.partyStoreSub = this.store
      .select(fromCommonStore.getAllParty)
      .subscribe((res: any) => {
        if (_.isEmpty(res)) {
          return;
        }
        this.partyList$ = res.data;
      });

    /*  this.partyList = this.partyCtrl.valueChanges
              .startWith(null)
              .map(name => name ? this.filterItems(name, 'Party') : this.partyList$.slice());*/
  }

  ngOnInit(): void {
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    this.filterData.inv_from_date = oneMonthAgo;
    this.finyearCombo();
    this.columns = [
      //{ width: 30, sortable: false, canAutoResize: false, draggable: false, resizeable: false, headerCheckboxable: true, checkboxable :true},
      {
        name: "SNo",
        prop: "sno",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
        sortable: false,
        headerClass: "text-center",
        cellTemplate: this.snoTemplate,
        toggle: true,
        isPrint: false,
      },
      {
        name: "PO No",
        prop: "inv_po_no",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
        cellClass: "text-center",
        align: "right",
        headerClass: "text-center",
      },
      {
        name: "Inv Date",
        prop: "fdate",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
        sortable: false,
      },
      {
        name: "Partycode",
        prop: "party_code",
        minWidth: 180,
        maxWidth: 180,
        width: 180,
        headerClass: "text-center",
        sortable: false,
      },
      {
        name: "Invoice Name",
        prop: "party_name",
        minWidth: 250,
        maxWidth: 250,
        width: 250,
        headerClass: "text-center",
        sortable: false,
      },
      {
        name: "Ref No",
        prop: "ref_no",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
      },
      {
        name: "Action",
        prop: "action",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        sortable: false,
        headerClass: "text-center",
        cellTemplate: this.editDeleteTemplate,
        isPrint: false,
      },
    ];

    this.toggleCol = Object.assign({}, this.columns);

    
    
  }

  hotkeys(event) {
    if (this.active) {
      if (event.altKey && event.keyCode === 65) {
        this.addEditInvoice("Add", "");
      }
      if (event.keyCode === 27) {
        //  this.bsModalRef.hide();
      }
    }
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.filterData.finyear = that.finyearList[0].finyear;
      that.pageCallback({ offset: 0 });
    });
  }
  onOpenedFilter(): void {
    setTimeout(function () {
      $("#pono").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getInvoiceList();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    }
    if (nextEl == "applyFilter") {
      this.applyFilter();
    } else {
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getInvoiceList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getInvoiceList();
  }

  getInvoiceList(): void {
    if (this.filterData.inv_from_date == "") {
      this.filterData.inv_from_date == "";
    } else {
      this.filterData.inv_from_date = this.datePipe.transform(
        this.filterData.inv_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filterData.inv_to_date == "") {
      this.filterData.inv_to_date == "";
    } else {
      this.filterData.inv_to_date = this.datePipe.transform(
        this.filterData.inv_to_date,
        "yyyy-MM-dd"
      );
    }
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      invoice_no: this.filterData.filterinvno,
      party: this.filterData.party,
      po_no: this.filterData.po_no,
      inv_from_date: this.filterData.inv_from_date,
      inv_to_date: this.filterData.inv_to_date,
      finyear: this.filterData.finyear,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllInvoice(params));
    this.isLoadMask = this.invoiceService
      .invoiceList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.invoiceData = res.data;

        let party = $("#filter_party_id").val();

        party = party == "" ? "All" : party;

        let subTitle: any;
        subTitle = {
          Party: party,
        };

        that.printConfig = {
          title: "Purchase Invoice",
          subTitle: subTitle,
          sumtitle: "TOTAL",
          columns: that.columns,
          rows: res.data,
        };
      });
  }

  clearFilter(): void {
    this.filterData.filterinvno = "";
    this.filterData.party = "";
    this.filterData.po_no = "";
    this.filterData.inv_from_date = "";
    this.filterData.inv_to_date = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getInvoiceList();
  }

  /*  filterItems(name: string, comboType: string) {
          let list: any[];
          if (comboType == "Party") {
              list = this.partyList$
          }
          name = _.escapeRegExp(name);
          return list.filter(item => (new RegExp(name, 'gi').test(item.name)));
      }*/

  displayFn(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Party") {
      list = this.partyList$;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { party_id: id });
      return fitem["party_name"];
    }
    return "";
  }

  addEditInvoice(mode: string, row: any): void {
    this.filterExpand = true;
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.filterExpand = true;
      this.getInvoiceList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          tabParent: "CLOTH",
          tabName: "ADD PURCHASE INVOICE",
          id: "AddEditInvoice",
          name: "EDIT PURCHASE INVOICE",
          mode: mode,
          data: row,
        },
      };
    } else if(mode == "Edit"){
      tabObj = {
        action: "NewTab",
        params: {
          tabParent: "CLOTH",
          tabName: "EDIT PURCHASE INVOICE",
          id: "AddEditInvoice",
          name: "EDIT PURCHASE INVOICE",
          mode: mode,
          data: row,
        },
      };
    }else if(mode == "View"){
      tabObj = {
        action: "NewTab",
        params: {
          tabParent: "CLOTH",
          tabName: "VIEW PURCHASE INVOICE",
          id: "AddEditInvoice",
          name: "VIEW PURCHASE INVOICE",
          mode: mode,
          data: row,
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }

  deleteInvoice(row: any): void {
    let that = this;
    swal({
      title: "Are you sure to delete this Invoice?",
      text: "You will not be able to recover this Invoice",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.invoiceService
          .deleteInvoice(row)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getInvoiceList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }

  @ViewChild("printPage") printPage;
  onPrintInvoice(row) {
    this.printConfig = {
      type: "invoice",
      title: "Sales Invoice",
      rows: row,
    };

    setTimeout(() => {
      this.printPage.printPreview();
    }, 100);
  }

  ngOnDestroy() {
    this.partyStoreSub.unsubscribe();
    this.invoiceStoreSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/invoice/invoice.component.ts